import { createFileRoute } from '@tanstack/react-router';

import { requirePermission } from '@/app/guards';
import {
  OrganizationSettingsPage,
  organizationSettingsQueryOptions,
} from '@/features/organization-settings';

export const Route = createFileRoute('/_authed/_active/org/settings')({
  staticData: { crumb: 'common:nav.organisationSettings', tours: ['org.settings'] },
  beforeLoad: ({ context }) => {
    requirePermission(context.me, 'settings.read');
  },
  loader: ({ context }) =>
    context.queryClient
      .query({ ...organizationSettingsQueryOptions(), staleTime: 'static' })
      .catch(() => undefined),
  component: OrganizationSettingsPage,
});
